import React from "react";
import PropTypes from "prop-types";

import { Button, Condition } from "..";

export function ConditionGroup({
  conditions,
  disabled,
  onAdd,
  conditionTypes,
}) {
  return (
    <div>
      <div>
        {conditions.map(({ condition, ...props }, i) => {
          return (
            <Condition
              key={condition.id}
              condition={condition}
              disabled={disabled}
              hideRemoveIcon={i === 0 || disabled}
              hideOperatorAction={conditions.length > 1}
              onAdd={onAdd}
              conditionTypes={conditionTypes}
              {...props}
            />
          );
        })}
      </div>
      {conditions.length > 1 && !disabled && (
        <Button
          data-test="condition-and-button"
          style={{ marginTop: "1em", marginLeft: "1em" }}
          basic
          type="button"
          onClick={() => {
            onAdd("AND");
          }}
        >
          AND
        </Button>
      )}
    </div>
  );
}

ConditionGroup.propTypes = {
  conditionTypes: PropTypes.array.isRequired,
  conditions: PropTypes.array,
  disabled: PropTypes.bool,
  onAdd: PropTypes.func.isRequired,
};

ConditionGroup.defaultProps = {
  conditions: [],
  disabled: false,
};

export default ConditionGroup;
